import {WCBaseComponent} from './WCBaseComponent.js';

const template = document.createElement('template');

template.innerHTML = `
  <span class="wc-list-info small text-gray-500 fw-lighter informacao">
    <span class="wc-list-info-span text-nowrap">
      <i class="wc-list-info-icon"></i>
    </span>
  </span>
`;

export class WCListInfo extends WCBaseComponent {

  constructor () {
    super();
  }

  render () {
    // let contentNodes = [...this.childNodes];
    let clone = template.cloneNode(true);
    let wcListInfo = clone.content.querySelector('.wc-list-info').cloneNode(false);
    let dataInfo = $$.tool.dataJSON(this.getAttribute('data-info'));
    if (dataInfo.length > 0) {
      dataInfo.forEach((info, index) => {
        let wcListInfoSpan = clone.content.querySelector('.wc-list-info-span').cloneNode(false);
        let wcListInfoIcon = clone.content.querySelector('.wc-list-info-icon').cloneNode(false);
        wcListInfoIcon.classList.add(info.icon);
        wcListInfoSpan.append(wcListInfoIcon);
        wcListInfoSpan.append(document.createTextNode(' ' + info.caption));
        wcListInfo.append(wcListInfoSpan);
        wcListInfo.append(document.createTextNode(' '));
      });
    }
    // this.innerHTML = '';
    this.replaceWith(wcListInfo);
  }

}